import React from "react";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory2";
import SellIcon from "@mui/icons-material/Sell";
import ForestIcon from "@mui/icons-material/Forest";

export default function SetupCard({
  config,
  setupSelected,
  isInsideIncludedLocality,
  baseDelivery,
  deliveryFee,
  onToggleSetup,
}) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3, height: "100%" }}>
      <CardContent sx={{ p: 2.25 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={setupSelected}
              onChange={(e) => onToggleSetup?.(e.target.checked)}
              disabled={!config.enabled}
            />
          }
          label="Add full setup service"
        />

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {config.blurb}
        </Typography>

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1 }}>
          <Chip
            icon={<InventoryIcon />}
            size="small"
            label="Stands & plates"
            variant="outlined"
          />
          <Chip
            icon={<SellIcon />}
            size="small"
            label="Tags & labels"
            variant="outlined"
          />
          <Chip
            icon={<ForestIcon />}
            size="small"
            label="Cloths & light florals"
            variant="outlined"
          />
        </Box>

        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Setup fee: ${Number(config.baseFee || 0).toFixed(2)}
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 0.5 }}>
          Setup includes the $25 base delivery. Outside included areas, we add
          only the travel overage:&nbsp;
          <Tooltip
            title="Normal delivery calculation minus the $25 base already included in setup."
            arrow>
            <span>delivery fee − ${Number(baseDelivery).toFixed(2)} base</span>
          </Tooltip>
          {setupSelected && !isInsideIncludedLocality ? (
            <>
              &nbsp; (current raw delivery fee: $
              {Number(deliveryFee).toFixed(2)})
            </>
          ) : null}
        </Typography>
      </CardContent>
    </Card>
  );
}
